export enum MedicallyReadyStatusChoices {
  YES = "YES",
  NO = "NO",
  UNKNOWN = "UNKNOWN",
}
